/**
 * Returns the appropriate time difference string based on how far back the date is
 * @param isoDate
 * @returns string
 */
export const getTimeDifferenceLabel = (isoDate: string): string => {
  const now = new Date().getTime();
  const inputDate = new Date(isoDate).getTime();
  const diffInSeconds = (now - inputDate) / 1000;

  if (diffInSeconds <= 30) {
    return 'Just now';
  } else if (diffInSeconds <= 90) {
    return '1 minute ago';
  } else if (diffInSeconds <= 44 * 60 + 30) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minutes ago`;
  } else if (diffInSeconds <= 89 * 60 + 30) {
    return '1 hour ago';
  } else if (diffInSeconds <= 23 * 60 * 60 + 59 * 60 + 30) {
    const hours = Math.floor(diffInSeconds / (60 * 60));
    return `${hours} hours ago`;
  } else if (diffInSeconds <= 41 * 60 * 60 + 59 * 60 + 30) {
    return '1 day ago';
  } else if (diffInSeconds <= 30 * 24 * 60 * 60 + 23 * 60 * 60 + 59 * 60 + 30) {
    const days = Math.floor(diffInSeconds / (24 * 60 * 60));
    return `${days} days ago`;
  } else if (diffInSeconds <= 44 * 24 * 60 * 60 + 23 * 60 * 60 + 59 * 60 + 30) {
    return '1 month ago';
  } else if (diffInSeconds <= 59 * 24 * 60 * 60 + 23 * 60 * 60 + 59 * 60 + 30) {
    return '2 months ago';
  } else if (diffInSeconds <= 365 * 24 * 60 * 60) {
    const months = Math.floor(diffInSeconds / (30 * 24 * 60 * 60));
    return `${months} months ago`;
  } else {
    const date = new Date(isoDate);
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }
};
